// When is an online registration and a player on the arbiter's list THE SAME
// ENTRY? One rule, used by both sides of the loop:
//
//   - the import, deciding a registration is already on the player list and must
//     not be added a second time (js/app.js, isRegAlreadyImported);
//   - the removal, deciding which registrations have to be withdrawn when the
//     arbiter deletes that player (js/ui/players.js, deletePlayer).
//
// They must not drift. Auto-import matches on FIDE id and name as well as on the
// registration id, so a removal that only withdrew `player.registrationId` left
// every other matching entry alive — and the next snapshot imported the player
// straight back. That is what made a removed player reappear on the next refresh,
// still registered, with nothing on their screen saying otherwise.
//
// Deliberately generous: a false match costs a registration the arbiter was
// deleting anyway, while a missed one resurrects a player they thought was gone.
export function registrationMatchesPlayer(reg, player) {
    if (!reg || !player) return false;

    if (player.registrationId && player.registrationId === reg.id) return true;

    if (reg.fideId && player.fideId && String(player.fideId) === String(reg.fideId)) return true;

    return !!(player.givenName && player.lastName && reg.givenName && reg.lastName
        && player.givenName.toLowerCase() === reg.givenName.toLowerCase()
        && player.lastName.toLowerCase() === reg.lastName.toLowerCase());
}
